<template>

    <div class="modal"
      v-if="showModal"
    >
      <div class="modal-content">
        <div class="modal-header">
          <span
            class="close-modal"
            @click="$emit('close')"
          >
            &times;
          </span>
          <slot name="header">
            <h3>{{ $t("about_the_project") }}</h3>
          </slot>
        </div>

        <div class="modal-body">
          <slot name="body">
            <h2 class="title"></h2>
            <p>{{ $t("about1") }}</p>
            <p class="about">{{ $t("about2") }}</p>
            <!-- <p class="about">{{ $t("about3") }}</p> -->
            <p class="about">
              {{ $t("data_source") }}:
              <a
                href="https://data.gov.hk/en-data/dataset/hk-dh-chpsebcddr-novel-infectious-agent/resource/6a1f233e-1d11-4acb-9aba-43730f6b6439"
                target="_blank"
                rel="nofollow noreferrer"
                class="link"
              >{{ $t("govt") }}</a>
            </p>
            <strong>{{ $t("credits") }}</strong>
            <p class="about">{{ $t("credits1") }}</p>
          </slot>
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <div class="centered">
              <button
                class="btn-fancy"
                style="text-align: center;"
                @click="$emit('close')"
              >{{ $t("Close") }}</button>
            </div>
          </slot>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'AboutModal',
  props: ['showModal']
};
</script>

<style lang="scss" scoped>
.centered{
  text-align: center;
}
.modal {
  color: black;
  display: block;
  position: fixed;
  z-index: 1000;
  position: fixed;
  left: 0;
  top: 0;
  bottom:0;
  right:0;
  margin:0;
  padding:0;
  width:100%;
  height: 100%;
  overflow: hidden;
  background-color: rgb(0,0,0);
  background-color: rgba(0,0,0,0.4);
}

.modal-header {
  color: white;
}

// .modal-body {padding: 2px 16px;}

.modal-footer {
  padding-bottom:10px;
}

.modal-content {
  position: relative;
  margin:5vh auto;
  max-height:88vh;
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  overflow-y:scroll;
  width: 80%;
  max-width: 640px;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
  animation-name: animatebottom;
  animation-duration: 0.4s
}


@keyframes animatebottom {
  from {bottom: -300px; opacity: 0}
  to {bottom: 0; opacity: 1}
}

/* Close Modal Button */
.close-modal {
  position:absolute;
  top:20px;
  right:20px;
  color:$hku-black;
  cursor: pointer;
  font-size: 30px;
  font-weight: bold;
  font-family: sans-serif;
}

.close-modal:hover,
.close-modal:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.modal-header h3 {
  color:$hku-black;
}

.modal-body {
  // margin: 20px 0;
}

.modal-default-button {
  float: right;
}


.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {

  width: 80%;
  margin: 0px auto;
  color: #000;
  padding: 20px 30px;
  // background-color: #fff;
  border-radius: 2px;
  // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;

}

@media only screen and (max-width:$breakpoint-tablet) {
  .modal-content {
    height:90%;
    overflow-y: scroll;
  }

  p {
    font-size:0.9em;
    line-height: 1.4;
  }
}



</style>
